import { render } from "./registration-expire-now-dialog.vue?vue&type=template&id=1454921a&scoped=true&ts=true"
import script from "./registration-expire-now-dialog.vue?vue&type=script&lang=ts"
export * from "./registration-expire-now-dialog.vue?vue&type=script&lang=ts"

import "./registration-expire-now-dialog.vue?vue&type=style&index=0&id=1454921a&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1454921a"]])

export default __exports__